import dishes from './reducers'

export { addDishes } from './actions'
export { getDishes, getDishesWithoutSizes, getDishById, getDishesOriginal, getDishesIds } from './selectors'

export default dishes
